import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Menu from './components/menu/Menu';
import Banner from './components/Banner/Banner';
import Presentation from './components/Presentation/Presentation';
import Features from './components/Features/Features';
import Content from './components/Content';
import HowItWorks from './components/HowItWorks/HowItWorks';
import ForWhom from './components/ForWhom/ForWhom';
import Footer from './components/Footer/Footer';
import ScreenShots from './components/ScreenShots/ScreenShots';
import Tariffs from './components/Tariffs/Tariffs';
import PartnersSlider from './components/PartnersSlider/PartnersSlider';
import AltcorAI from './components/AltcorAI/AltcorAI';
import ContactBanner from './components/ContactBanner/ContactBanner';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse/TermsOfUse';
import CookieConsent from './components/CookieConsent/CookieConsent'; // Импортируем компонент
import './App.css';
import './fonts.css';

function HomePage() {
  return (
    <div>
      <Menu />
      <Banner />
      <Presentation />
      <ScreenShots />
      <AltcorAI />
      <HowItWorks />
      <Tariffs />
      <ForWhom />
      <PartnersSlider />
      <ContactBanner />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
        </Routes>
        {/* Cookie Consent Banner - показывается на всех страницах */}
        <CookieConsent />
      </div>
    </Router>
  );
}

export default App;